var map = {
	"./EarthIconWhite.svg": 267,
	"./FeedBackIcon.svg": 618,
	"./Inventory.svg": 188,
	"./No.svg": 64,
	"./NoRed.svg": 619,
	"./VideoIcon.svg": 620,
	"./addItem.svg": 621,
	"./addToCart.svg": 622,
	"./back.svg": 132,
	"./barcode.svg": 268,
	"./blueDrop.svg": 194,
	"./cameraIcon.svg": 262,
	"./delete.svg": 104,
	"./deleteSweep.svg": 623,
	"./earthIcon.svg": 624,
	"./edit.svg": 265,
	"./englandFlagIcon.svg": 259,
	"./filterIcon.svg": 190,
	"./gesture.svg": 625,
	"./greenDelete.svg": 626,
	"./greenDrop.svg": 195,
	"./greyDrop.svg": 136,
	"./handIcon.svg": 627,
	"./helpIcon.svg": 134,
	"./lowAmount.svg": 192,
	"./manual.svg": 628,
	"./manualIcon.svg": 105,
	"./plus.svg": 263,
	"./profile.svg": 629,
	"./profileIcon.svg": 269,
	"./questionCircle.svg": 270,
	"./removeFromCart.svg": 630,
	"./restore.svg": 631,
	"./scanner.svg": 632,
	"./score1.svg": 271,
	"./score2.svg": 272,
	"./score3.svg": 196,
	"./score4.svg": 273,
	"./score5.svg": 274,
	"./scoreNan.svg": 65,
	"./searchIcon.svg": 191,
	"./settings.svg": 260,
	"./settingsFlagIcon.svg": 275,
	"./settingsGrey.svg": 633,
	"./settingsPasswordIcon.svg": 276,
	"./settingsVideoIcon.svg": 277,
	"./shoppingCart.svg": 133,
	"./swedenFlagIcon.svg": 258,
	"./touchIcon.svg": 634,
	"./yes.svg": 135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 193;